import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import {formatDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";


class AllowanceInfoView extends Component {

    constructor(props) {
        super(props);

        this.state = {

            isLoading: true,
            isError: false,
        }
    }

    componentDidMount(){
        const {
            allowancenumber,
        } = this.props.match.params;

        // console.log(allowancenumber);
        const allowance = this.props.allowances[allowancenumber]; 
        if(!allowance){
            this.setState({
                isLoading: true,
            })

        }

        this.props.allowanceActions.getAllowanceInfo({allowancenumber}).then((result=>{
            this.setState({
                isLoading: false,
            })
        }));

    }

    //產生畫面
    render() {
        const {isLoading} = this.state;

        if(isLoading){
            return null;
        }
        const {
            allowancenumber,
        } = this.props.match.params;

        
        const allowance = this.props.allowances[allowancenumber]; 
        const {            
            // createtime,
            detail,
            buyername,
            buyercrn,
        } = allowance;

        const {
            allowancedate,
            // totalamount,
            taxamount,
            yearmonth,
            invoicenumber,
            invoicedate,
            pdtlist
        } = detail;

        const allowanceDayValue = formatDate(allowancedate, 'YYYY/MM/DD');
        const invoiceDayValue = formatDate(invoicedate, 'YYYY/MM/DD');


        return (

            <div id="create-allowance">
                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item active">
                            <a>折讓單明細</a>
                        </li>
                    </ul>
                    <div className="button-group">
                    <CupoySrefView
                        statename={CupoyRouter.STATES.PRINT_ALLOWANCE}
                        params={{
                            allowancenumber,
                        }}
                        target="_blank"
                        className="button blue"
                    >
                        列印
                    </CupoySrefView>
                      
                    </div>
                </div>

                <div className="scroll-content">
                    <div
                        className="form"
                        style={{
                        minHeight: '100%'
                    }}>
                        <div className="block-form">
                            <h3 className="block-title">基本資訊</h3>
                            <div className="block-form-row">
                                <label
                                    className="block-form-col">
                                    <h5 className="title">
                                        原始發票號碼
                                    </h5>
                                    <div className="description">{invoicenumber}</div>
                                </label>
                            </div>
                            <div className="block-form-row">         
                                <label className="block-form-col">
                                    <h5 className="title">原始發票期別</h5>
                                    <div className="description">{yearmonth}</div>
                                </label>

                                <label className="block-form-col">
                                    <h5 className="title">原始發票開立日期</h5>
                                    <div className="description">{invoiceDayValue}</div>
                                </label>
                            </div>

                            <div className="block-form-row">
                                <label
                                    className="block-form-col">
                                    <h5 className="title">
                                        折讓單號碼
                                    </h5>
                                    <div className="description">{allowancenumber}</div>
                                </label>
                                <label className="block-form-col">
                                    <h5 className="title">折讓日期</h5>
                                    <div className="description">{allowanceDayValue}</div>
                                </label>
                            </div>
                            <div className="block-form-row">
                                <label
                                    className="block-form-col">
                                    <h5 className="title">
                                        買受人抬頭
                                    </h5>
                                    <div className="description">{buyername}</div>
                                </label>
                                <label className="block-form-col">
                                    <h5 className="title">買受人統編</h5>
                                    <div className="description">{buyercrn}</div>
                                </label>
                            </div>                            
                        </div>
                        <div className="block-form">
                            <h3 className="block-title">折讓商品資訊</h3>
                            <div className="block-form-wrapper">
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">商品名稱</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">商品編號</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">折讓數量</h5>
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">商品單價(未稅)</h5>
                                    </label>

                                </div>

                                {pdtlist.map((product, index) => {


                                    return (
                                        <div className="block-form-row" key={index}>
                                            <label className="block-form-col">
                                                <div className="description">{product.pdtname}</div>
                                            </label>
                                            <label className="block-form-col">
                                                <div className="description">{product.pdtid}</div>
                                            </label>
                                            <label className="block-form-col">
                                                <div className="description">{product.pdtcount}</div>
                                            </label>
                                            <label className="block-form-col">
                                                <div className="description">{product.pdtprice}</div>
                                            </label>
                                        </div>
                                    )
                                })}
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">折退金額（含稅）</h5>
                                        <p className="description">
                                            {taxamount}
                                        </p>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
const mapStateToProps = function (state) {
    return {allowances: state.allowance.allowances};
};

const mapActionToProps = function (dispatch) {
    return {
        allowanceActions: bindActionCreators(actionCreators.allowanceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(AllowanceInfoView);


// WEBPACK FOOTER //
// ./src/components/allowance/AllowanceInfoView.jsx